import { useContext } from 'react';
import { ICurrentAddresseeContext, CurrentAddresseeContext } from '../contexts';

export const useCurrentAddressee = (): ICurrentAddresseeContext => {
  const context = useContext(CurrentAddresseeContext);

  return context;
};
